





















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { ImageKinds } from "../../../domain/document";
import { MovableImageItem } from "../../../domain/document/items";
import {
  IDrawableItemEditable,
} from ".";
import { DocumentPageEditorContextMenuMixin } from "./mixins";
import { ObjectClipboardMixin } from "./objects/mixins";

@Component
export default class DocumentPageMenu extends Mixins(DocumentPageEditorContextMenuMixin, ObjectClipboardMixin) {
  @Prop()
  focusedSource: IDrawableItemEditable;

  @Prop()
  isImageRegistrationEnable: boolean;
  
  data(): any {
    return {
      isActive: false,
      isPastingImageFromClipboard: false,
    };
  }
  isActive: boolean;
  isPastingImageFromClipboard: boolean;

  mounted(): void {
    // メニュー以外をクリックした場合クローズできるようwindowにイベントを追加
    window.addEventListener("pointerdown", this.onWindowMouseDowned, false);
  }

  onWindowMouseDowned(event: PointerEvent): void {
    this.isActive = false;
  }

  destroyed(): void {
    window.removeEventListener("pointerdown", this.onWindowMouseDowned, false);
  }

  onMenuClick() {
    // 親のmousedownイベントでフォーカスが失われるトリガがあるため、親への通知を止めたうえでメニュークローズのトリガをクリックにも追加
    this.isActive = false;
  }

  handlePageMouseClicked(event: PointerEvent): void {
    this.isActive = false;
    if (event.button === 2) {
      this.updateLocation(event);
      this.size = this.emptyThresholdSize;  // 一旦非表示にする.表示されない閾値のサイズに一旦更新する.
      setTimeout(() => {
        if (!this.focusedSource) {
          this.isActive = true;
          this.updateSize();
        }
      }, 500);
    }
  }

  get shouldShow(): boolean {
    return (this.shouldAlwaysShow || this.isActive)
        // メニューのコンテンツが表示されてるかの情報がないので、サイズで判断する.閾値より小さければなしと判断する.
        && this.isVisibleSize;
  }

  get shouldAlwaysShow(): boolean {
    return this.$configuration.debug.shouldAlwaysShowObjectMenu;
  }

  @Watch("focusedSource")
  onFocusedSourceUpdated(newValue: IDrawableItemEditable): void {
    if (!!newValue) {
      this.isActive = false;
    }
  }

  get isPastableSourceFromClipboard(): boolean {
    return DomainRegistry.localhost.getImageClipboardService().isAvailable()
      && this.isImageRegistrationEnable;
  }

  get isImagePastableFromClipboard(): boolean {
    return this.$configuration.behavior.document.editor.imageDropper.isEnable && this.isPastableSourceFromClipboard;
  }

  async pasteSourceFromClipboard(): Promise<void> {
    try {
      this.isPastingImageFromClipboard = true;
      const guid = await DomainRegistry.localhost.getImageClipboardService().registerClippedImage();
      if (!guid) {
        this.$warn("貼り付け失敗", "クリップボードに画像がありませんでした.");
      } else {
        this.addItem(await MovableImageItem.fromImageSource(this.location, await DomainRegistry.document.getDocumentRepository().createImageSourceFromCachedGuid(guid), ImageKinds.Image));
      }
    } catch (e) {
      this.$error("貼り付け失敗", "クリップボード画像登録中にエラーが発生しました.", e);
    } finally {
      this.isPastingImageFromClipboard = false;
    }
  }

  async pasteSourceFromObjectClipboard() {
    this.addItem(await this.getNewObjectFromObjectClipboard(this.location));
  }
}
